import {JSON_OBJECT} from "../shared/json/helpers";
import {getLabelerImportProcessUrl, getLabelerTeamMemberInviteUrl, LabelerTeamMember} from "./types";
import {ApiBase} from "../shared/api_base";
import {
  LabelerImportProcessRequest,
  LabelerImportProcessResponse,
  LabelerTeamMemberInviteRequest,
  LabelerTeamMemberInviteResponse
} from "../fyneai-common/api/types";

export class Api extends ApiBase {

  private static instance: Api;

  static getInstance(): Api {
    if (!Api.instance) {
      Api.instance = new Api();
    }
    return Api.instance;
  }

  private constructor() {
    super();
  }

  async labelerTeamMemberInvite(projectId: string, email: string, firstname: string, lastname: string): Promise<LabelerTeamMember | undefined> {
    let teamMember: LabelerTeamMember;
    const resp = await (await this._asyncPostJson(getLabelerTeamMemberInviteUrl(), null, {
      projectId,
      email,
      firstname,
      lastname,
    } as LabelerTeamMemberInviteRequest))
      .json() as LabelerTeamMemberInviteResponse;
    if (resp) {
      teamMember = JSON_OBJECT.deserializeObject(resp.teamMember, LabelerTeamMember);
    }
    return teamMember;
  }

  async labelerImportProcess(projectId: string, datasetId: string, importId: string): Promise<boolean | undefined> {
    const resp = await (await this._asyncPostJson(getLabelerImportProcessUrl(), null, {
      projectId,
      datasetId,
      importId,
    } as LabelerImportProcessRequest))
      .json() as LabelerImportProcessResponse;
    return resp.status.code === 200;
  }
}